import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=41d5550a"
import script from "./EditPassword.vue?vue&type=script&lang=ts"
export * from "./EditPassword.vue?vue&type=script&lang=ts"
import style0 from "./EditPassword.vue?vue&type=style&index=0&id=41d5550a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports